import React, { useState } from "react";
import { Gamepad2, Truck, DollarSign, Star, RotateCcw } from "lucide-react";
import { SIM_LOADS } from "../courseData";

const DispatchSim = () => {
  const [i, setI] = useState(0);
  const [revenue, setRevenue] = useState(0);
  const [rep, setRep] = useState(0);
  const [feedback, setFeedback] = useState(null);
  const load = SIM_LOADS[i];
  const done = i >= SIM_LOADS.length;

  const advance = (msg, addRev, addRep) => {
    setRevenue((r) => r + addRev);
    setRep((r) => r + addRep);
    setFeedback({ msg, addRev, addRep });
  };

  const accept = () => advance(
    load.trap ? "You booked a bad load — margin lost and reputation dipped." : "Booked a solid load. Carrier is happy.",
    load.rate, load.trap ? -1 : 1);
  const negotiate = () => {
    const win = Math.random() < 0.6;
    if (win) advance(`Broker agreed to +10%! You added $${Math.round(load.rate * 0.1)}.`, Math.round(load.rate * 1.1), 1);
    else advance("Broker wouldn't budge and moved on. No load booked.", 0, 0);
  };
  const decline = () => advance(
    load.trap ? "Smart pass — you avoided a losing load." : "You passed on a good load; carrier lost revenue today.",
    0, load.trap ? 1 : -1);

  const next = () => { setFeedback(null); setI((v) => v + 1); };
  const restart = () => { setI(0); setRevenue(0); setRep(0); setFeedback(null); };

  const rating = rep >= 3 ? "Elite Dispatcher" : rep >= 1 ? "Solid Dispatcher" : rep <= -2 ? "Needs Coaching" : "Getting Started";

  return (
    <div className="sim" data-testid="dispatch-sim">
      <h3><Gamepad2 size={18} /> Run Your Dispatch Day</h3>
      <p className="sim-intro">Evaluate each load and decide: book it, negotiate, or pass. Protect your carrier's margin and reputation.</p>
      <div className="sim-stats">
        <span data-testid="sim-revenue"><DollarSign size={14} /> Revenue: ${revenue.toLocaleString()}</span>
        <span data-testid="sim-rep"><Star size={14} /> Reputation: {rep}</span>
        <span><Truck size={14} /> Load {Math.min(i + 1, SIM_LOADS.length)} / {SIM_LOADS.length}</span>
      </div>

      {done ? (
        <div className="sim-end" data-testid="sim-result">
          <h4>Day complete — you're a <strong>{rating}</strong></h4>
          <p>Total revenue booked: <strong>${revenue.toLocaleString()}</strong> · Reputation score: <strong>{rep}</strong></p>
          <button className="btn btn-primary" onClick={restart} data-testid="sim-restart"><RotateCcw size={15} /> Play again</button>
        </div>
      ) : feedback ? (
        <div className="sim-feedback" data-testid="sim-feedback">
          <p>{feedback.msg}</p>
          <p className="sim-delta">{feedback.addRev > 0 ? `+$${feedback.addRev.toLocaleString()} revenue ` : ""}{feedback.addRep !== 0 ? `${feedback.addRep > 0 ? "+" : ""}${feedback.addRep} reputation` : ""}</p>
          <button className="btn btn-primary" onClick={next} data-testid="sim-next">
            {i === SIM_LOADS.length - 1 ? "See results" : "Next load"}
          </button>
        </div>
      ) : (
        <div className="sim-load" data-testid="sim-load">
          <div className="sim-lane">{load.lane}</div>
          <div className="sim-meta">
            <span>{load.equipment}</span><span>{load.miles} mi loaded</span>
            <span>{load.deadhead} mi deadhead</span><span className="sim-rate">${load.rate}</span>
          </div>
          <p className="sim-note">{load.note}</p>
          <div className="sim-actions">
            <button className="game-chip" onClick={accept} data-testid="sim-accept">Book it</button>
            <button className="game-chip" onClick={negotiate} data-testid="sim-negotiate">Negotiate</button>
            <button className="game-chip" onClick={decline} data-testid="sim-decline">Pass</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DispatchSim;
